import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import REFINANCEIRQTakeCashOutView from "../views/REFINANCEIRQTakeCashOutView";
import AppRoutes from "../config/AppRoutes";
import ApiConfig from "../config/ApiConfig";
import { getUserId } from "../util/storage/accessTokenStorage";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object, string } from "yup";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqTakeCashOutPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    const navigationsAwayGenerated =
      customNavigationMap.RefinanceIrqTakeCashOutPage;

    const navigationsAway = {
      ...navigationsAwayGenerated,
      Secondary: navigationsAwayGenerated.Primary,
    };

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            takeCashOut: bool().required(),
          })}
        >
          <REFINANCEIRQTakeCashOutView
            content={contentMap.RefinanceIrqTakeCashOutPage}
            navigationsAway={navigationsAway}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqTakeCashOutPage);
